import { Isi } from './components/isi/isi'
import { EndMatter } from './components/endMatter/endMatter'
import { StyledFooter } from './footer.styles'
import { PageNav } from './components/pageNav/pageNav'

export const Footer = ({ refs = false, renderNav = false, renderIsi = false, showIndication = true, removePartOfTheIsi = false}) => {
  return (
    <>
      {/* {renderNav && <PageNav />} */}
      {renderIsi && <Isi showIndication={showIndication} removePartOfTheIsi={removePartOfTheIsi}>{refs}</Isi>}
      {(renderNav && renderIsi) && <PageNav />}
      <StyledFooter>
        <EndMatter />
      </StyledFooter>
    </>
  )
}
